// Generated by purs version 0.15.15
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Effect from "../Effect/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var Slot = /* #__PURE__ */ (function () {
    function Slot(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Slot.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Slot(value0, value1, value2);
            };
        };
    };
    return Slot;
})();
var replaceSlot = function (v) {
    return v.value0;
};
var newSlot = function (dict) {
    return dict.newSlot;
};
var destroySlot = function (v) {
    return v.value1;
};
var appendSlot = function (v) {
    return v.value2;
};
var monadReplaceReaderT = function (dictMonadReplace) {
    var MonadCleanup1 = dictMonadReplace.MonadCleanup1();
    var Monad0 = MonadCleanup1.Monad0();
    var map1 = Data_Functor.map(((Monad0.Bind1()).Apply0()).Functor0());
    var newSlot1 = newSlot(dictMonadReplace);
    var monadReaderT = Control_Monad_Reader_Trans.monadReaderT(Monad0);
    var monadCleanupReaderT = Control_Monad_Cleanup.monadCleanupReaderT(MonadCleanup1);
    return {
        newSlot: (function () {
            var slotWith = function (env) {
                return function (slot) {
                    return new Slot(function (m) {
                        return replaceSlot(slot)(Control_Monad_Reader_Trans.runReaderT(m)(env));
                    }, destroySlot(slot), map(slotWith(env))(appendSlot(slot)));
                };
            };
            return function (env) {
                return map1(slotWith(env))(newSlot1);
            };
        })(),
        Monad0: function () {
            return monadReaderT;
        },
        MonadCleanup1: function () {
            return monadCleanupReaderT;
        }
    };
};
export {
    newSlot,
    Slot,
    replaceSlot,
    destroySlot,
    appendSlot,
    monadReplaceReaderT
};
